import type { OrderDirectionType, OrderTooltipType } from '../types';
import { EDimensionKey } from '~/presentation/reports/common/type';

export enum ETooltipCategory {
  ALPHABETICAL = 'ALPHABETICAL',
  NUMERIC = 'NUMERIC',
  DATE = 'DATE',
}

export const TooltipPresets: Record<ETooltipCategory, Record<OrderDirectionType, string>> = {
  [ETooltipCategory.ALPHABETICAL]: { ASC: 'A-Z', DESC: 'Z-A' },
  [ETooltipCategory.NUMERIC]: { ASC: 'Lowest first', DESC: 'Highest first' },
  [ETooltipCategory.DATE]: { ASC: 'Oldest first', DESC: 'Newest first' },
};

export const DEFAULT_TOOLTIP = TooltipPresets[ETooltipCategory.NUMERIC];

export const reportOrderTooltip: OrderTooltipType = {
  day: TooltipPresets[ETooltipCategory.DATE],
  order_date: TooltipPresets[ETooltipCategory.DATE],
  month: TooltipPresets[ETooltipCategory.DATE],
  year: TooltipPresets[ETooltipCategory.DATE],
  hour: TooltipPresets[ETooltipCategory.DATE],
  quarter: TooltipPresets[ETooltipCategory.DATE],
  week: TooltipPresets[ETooltipCategory.DATE],
  [EDimensionKey.DEVICE]: TooltipPresets[ETooltipCategory.ALPHABETICAL],
  [EDimensionKey.VISITOR]: TooltipPresets[ETooltipCategory.ALPHABETICAL],
  [EDimensionKey.VERSION]: TooltipPresets[ETooltipCategory.ALPHABETICAL],
  [EDimensionKey.TRAFFIC_SOURCE]: TooltipPresets[ETooltipCategory.ALPHABETICAL],
};
